import { render, staticRenderFns } from "./rewardAccountShaiDian.vue?vue&type=template&id=d2fb6f68&"
import script from "./rewardAccountShaiDian.vue?vue&type=script&lang=js&"
export * from "./rewardAccountShaiDian.vue?vue&type=script&lang=js&"
import style0 from "./rewardAccountShaiDian.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports